import React from "react";
import ReactTooltip from "react-tooltip";

const MIN_MAX_LENGTH = 1;
const MAX_MAX_LENGTH = 100000;

function TextAnswerMaxLengthInput({ answer, handleChange, isDisabled = false }) {
    const hasMask = Boolean(answer.inputMask?.mask);
    const disabled = isDisabled || hasMask;
    const tooltipId = `maxlength-tooltip-${answer.sequenceId}`;

    return (
        <a data-tip data-for={tooltipId}>
            <div className="feedback-container">
                <input
                    type="number"
                    placeholder="Max length (optional)"
                    name="maxLength"
                    min={MIN_MAX_LENGTH}
                    max={MAX_MAX_LENGTH}
                    step={1}
                    value={answer.maxLength && answer.maxLength > 0 ? String(answer.maxLength) : ""}
                    onChange={handleChange}
                    disabled={disabled}
                    data-testid="answer-max-length-input"
                />
                <ReactTooltip id={tooltipId} className="tooltip">
                    <p>Limit the number of characters the user can type in this field.</p>
                    <p>Leave empty for no limit.</p>
                    {hasMask && (
                        <p>
                            <b>Disabled because a mask is set.</b>
                        </p>
                    )}
                </ReactTooltip>
            </div>
        </a>
    );
}

export default TextAnswerMaxLengthInput;
